document.addEventListener('DOMContentLoaded', function () {
    const heroSwiper = new Swiper('.image-slider-swiper', {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
      });
});